import { forwardRef, Link, LinkProps } from "@chakra-ui/react";
import { useDocumentRetrieve } from "gen/endpoints/documents/documents";
import { useTranslation } from "react-i18next";
import { useToast } from "shared/components/toast/useToast";
import { downloadFileFromUrl } from "shared/utils/utils";

export interface DocumentDownloadLinkProps extends LinkProps {
  documentId: string;
}

export const DocumentDownloadLink = forwardRef<
  DocumentDownloadLinkProps,
  "button"
>(({ documentId, ...props }, ref) => {
  const { t } = useTranslation(["common"]);
  const { showToast, showErrorToast } = useToast();
  const { refetch } = useDocumentRetrieve(documentId, {
    query: { enabled: false },
  });

  const onClick = async () => {
    try {
      const { data } = await refetch();
      if (data?.url) {
        downloadFileFromUrl(data.url);
      } else {
        showToast({
          message: t("common:error.generic"),
          variant: "error",
        });
      }
    } catch (err) {
      showErrorToast(err);
    }
  };
  return <Link onClick={onClick} ref={ref} {...props} />;
});

DocumentDownloadLink.displayName = "DocumentDownloadLink";
